import React from "react";
import sharedStyles from "../styles/SharedStyles.module.css";
import blockedEnd from "../assets/blocked_end.png";

const Room17 = ({ goBack }) => {
  return (
    <div className={sharedStyles.centeredContainer}>
      <h1 className={sharedStyles.pageTitle}>Unnamed Chamber</h1>
      <p className={sharedStyles.pageDescription}>
        The walls here are uneven, carved by time and unseen forces.
      </p>

      <div className={sharedStyles.sceneContainer}>
        {/* Room Image */}
        <img
          src={blockedEnd}
          alt="Cave Room"
          className={sharedStyles.sceneImage}
        />
      </div>

      {/* Go Back Button */}
      <button className={sharedStyles.backButton} onClick={goBack}>
        ← Go Back
      </button>
    </div>
  );
};

export default Room17;